const reviewsUrl =
    "http://localhost/blog.djishop.cz/bin/store_reviews.php";
const localStorageKey = "storeReviews";
const expirationInMinutes = 1440; // 1 day

function setLocalStorage(name, value, expirationInMinutes) {
    const now = new Date();
    const expirationDate = new Date(
        now.getTime() + expirationInMinutes * 60000
    );
    const item = {
        value: value,
        expiration: expirationDate.toISOString(),
    };
    localStorage.setItem(name, JSON.stringify(item));
}

function getLocalStorage(name) {
    const itemStr = localStorage.getItem(name);

    if (!itemStr) {
        return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now > new Date(item.expiration)) {
        localStorage.removeItem(name);
        return null;
    }

    return item.value;
}

function fetchStoreReviews() {
    fetch(reviewsUrl)
        .then((response) => response.json())
        .then((data) => {
            if (!data.error) {
                setLocalStorage(localStorageKey, data, expirationInMinutes);
                displayReviews(data);
                displayReviewsList(data);
            } else {
                console.error(data.error);
            }
        })
        .catch((error) => {
            console.error("Failed to fetch store reviews:", error);
        });
}

function initReviews() {
    const cachedReviews = getLocalStorage(localStorageKey);

    if (cachedReviews) {
        displayReviews(cachedReviews);
        displayReviewsList(cachedReviews);
    } else {
        fetchStoreReviews();
    }
}

function displayReviews(data) {
    const reviewsDiv = document.getElementById("google-reviews");

    if (reviewsDiv) {
        // PouĹľitĂ­ dat total_reviews a average_rating
        const totalRatings = data.total_reviews;
        const averageRating = data.average_rating;

        let html = `
    <a href="https://maps.app.goo.gl/rij2RPPjz7BiAmdn6" style="text-decoration:none" target="_blank">
        <div class="review-container">
            <img src="https://www.djishop.cz/out/djicesko2/img/google.svg" width="44" alt="Google reviews" />
            <div class="review-content">
                <div class="google-rating">${averageRating} <span>(${totalRatings})</span></div>
                <div class="stars">${generateStars(averageRating)}</div>
            </div>
        </div>
        </a>
    `;

        reviewsDiv.innerHTML = html;
    }
}

function displayReviewsList(data) {
    const reviewsDiv = document.getElementById("reviews_list");

    if (reviewsDiv) {
        const totalRatings = data.total_reviews;
        const averageRating = data.average_rating;

        let html = ``;

        html += `<a href="https://maps.app.goo.gl/rij2RPPjz7BiAmdn6" style="text-decoration:none" target="_blank">
        <div class="review-container">
            <img src="https://www.djishop.cz/out/djicesko2/img/google.svg" width="44" alt="Google reviews" />
            <div class="review-content">
                <div class="google-rating">${averageRating} <span>(${totalRatings})</span></div>
                <div class="stars">${generateStars(averageRating)}</div>
            </div>
        </div>
    </a>`;

        html += `<div class="reviews">`;

        data.reviews.forEach((review) => {
            if (review.rating > 4.0) {
                html += `
            <div class="review">
            <div class="review-author-box">
            <div class="review-photo"><img src="${review.images && review.images.length > 0
                        ? review.images[0].thumbnail
                        : ""
                    }" /></div>
            <div class="review-author"><a href="${review.link
                    }" target="_blank">${review.username}</a></div>
            <div class="review-date">${review.date}</div>
            </div>
                <div class="stars">${generateStars(review.rating)}</div>
                <div class="review-text">${review.description}</div>
            </div>
        `;
            }
        });

        html += `</div>`;

        reviewsDiv.innerHTML = html;
    }
}

function generateStars(rating) {
    var stars = "";
    for (var i = 0; i < 5; i++) {
        if (i < Math.round(rating)) {
            stars += "★";
        } else {
            stars += "☆";
        }
    }
    return stars;
}

document.addEventListener("DOMContentLoaded", function () {
    initReviews();
});